import React, { FC, useLayoutEffect, useState, useEffect, useRef } from 'react'
import { IonInput } from '@ionic/react'
import { getPlatform } from '@utils'
import mktController from 'controllers/mktController'
import markerImg from '@img/mapMarker.png'
import LBSImg from '@img/LBS.png'
import { debounce, filter, find } from '@dt/fe-utils/dist/lodash'
import Empty from './empty'
import './map.scss'

const { isWeixinMiniProgram } = getPlatform()

// interface
interface IProps {
  /** 所处引用是要传入不同的id */
  id: string;
  // 地图中心点
  center?: {
    lat: number;
    lng: number;
  };
  // 当前选中的目标
  activeMarker: string;
  // 门店信息
  stores: IViewStore[];
  onPointClick?(store: IViewStore): void;
  onSelectAddress?: (info: any) => void;
  onError?: (error: any) => void;
}
/** 地图搜索字段 */
const keyList = [
  'Br', 'Cr', 'Vr', 'Ir', 'Wr', 'Dr', 'Er', 'Fr', 'Gr', 'Hr',
  'Jr', 'Ar', 'Kr', 'Lr', 'Mr', 'Nr', 'Or', 'Pr', 'Qr', 'Rr',
  'Sr', 'Tr', 'Ur', 'Xr', 'Yr', 'Zr', 'qk', 'fR'
]
/** 缓存搜索字段 */
let saveBdKey = ''

let map: any
let marker: any
const BaiduMap: FC<IProps> = (props: IProps) => {
  const { id, center, stores, onSelectAddress, onError } = props
  const baiduRef: any = useRef<any>(null)
  const [isSearch, setIsSearch] = useState<boolean>(false)
  const [searchArr, setSearchArr] = useState<any[]>([])
  const [searchEmpty, setSearchEmpty] = useState<boolean>(false)
  const [recomArr, setRecomArr] = useState<any[]>([])
  const [city, setCity] = useState<string>('')
  const [isDraging, setIsDraging] = useState<boolean>(false)
  // Component Event
  const hanlderSelect = (info: any) => {
    const geo: any = new BMap.Geocoder()
    geo.getLocation(info.point, (res: any) => {
      console.log('getLocation_________', res)
      onSelectAddress && onSelectAddress({
        ...info,
        cityInfo: res.addressComponents
      })
    }, {
      poiRadius: 0,
      numPois: 0
    })
  }
  const searchLocal = debounce((value: string) => {
    if (map) {
      setSearchEmpty(false)
      const myKeys = value
      const local = new BMap.LocalSearch(map, {
        onSearchComplete: (res: any) => {
          console.log('百度返回搜索===>', res)
          if (res) {
            const list = []
            const num = res?.getCurrentNumPois?.() || 0
            for (let i = 0; i < num; i++) {
              const poi = res?.getPoi?.(i)
              /** 过滤不带 src_type 的数据 */
              if ('src_type' in poi && poi.src_type) {
                list.push(poi)
              }
            }
            console.log('百度返回搜索列表===>', list)
            setSearchArr(list)
            !list?.length && !!myKeys && setSearchEmpty(true)
          } else {
            setSearchArr([])
            !!myKeys && setSearchEmpty(true)
          }
        }
      })
      local.search(myKeys, {
        forceLocal: false,
      })
    }
  }, 300)
  const getNearBy = (lng: number, lat: number) => {
    const pt = new BMap.Point(lng, lat)
    const geo: any = new BMap.Geocoder()
    geo.getLocation(pt, (res: any) => {
      setCity(res.addressComponents.city)
      /** 过滤行政区划数据 */
      const resRecom: any[] = filter(res.surroundingPois, (poi: any) => !poi.tags.includes('行政区划'))
        .map((item: any) => {
          item.province = res.addressComponents.province
          return item
        })
      setRecomArr(resRecom)
    }, {
      poiRadius: 1000,
      numPois: 50
    })
    mapToCenter(pt)
  }
  const mapToCenter = (point: any) => {
    map.centerAndZoom(point, 18)
    map.panTo(point)
  }
  const handleError = (info) => {
    setIsSearch(true)
    onError && onError(info)
  }

  const initBMap = async (centerInfo: any) => {
    if (baiduRef && baiduRef.current) {
      map = new BMap.Map(baiduRef.current) // 创建Map实例
      map.addControl(new BMap.NavigationControl()) // 平移缩放控件
      const myIcon = new BMap.Icon(markerImg, new BMap.Size(20, 32))
      if (centerInfo) {
        marker = new BMap.Marker(new BMap.Point(centerInfo.lng, centerInfo.lat), {
          icon: myIcon
        })
        map.addOverlay(marker)
        setTimeout(() => {
          getNearBy(centerInfo.lng, centerInfo.lat)
        }, 300)
      } else {
        mktController.openLBS().then((location: any) => {
          const currPos = {
            lat: location.latitude,
            lng: location.longitude,
          }
          marker = new BMap.Marker(new BMap.Point(currPos.lng, currPos.lat), {
            icon: myIcon
          })
          map.addOverlay(marker)
          setTimeout(() => {
            getNearBy(currPos.lng, currPos.lat)
          }, 300)
        }, (error: any) => {
          if (isWeixinMiniProgram) {
            handleError(error)
          } else {
            const geolocation: any = new BMap.Geolocation()
            geolocation.getCurrentPosition((res: any) => {
              if (res) {
                const currPos = {
                  lat: res.latitude,
                  lng: res.longitude,
                }
                marker = new BMap.Marker(new BMap.Point(currPos.lng, currPos.lat), {
                  icon: myIcon
                })
                map.addOverlay(marker)
                setTimeout(() => {
                  getNearBy(currPos.lng, currPos.lat)
                }, 300)
              } else {
                handleError(error)
              }
            })
          }
        })
      }
      // 拖拽事件
      map.addEventListener('dragstart', () => {
        setIsDraging(true)
        map.removeOverlay(marker)
      })

      map.addEventListener('dragend', () => {
        setIsDraging(false)
        map.removeOverlay(marker)
        const center = map.getCenter()
        marker = new BMap.Marker(new BMap.Point(center.lng, center.lat), {
          icon: myIcon
        })
        map.addOverlay(marker)
        getNearBy(center.lng, center.lat)
      })
    }
  }
  useLayoutEffect(() => {
    if (!window.initBaiduMapSDKStatus) return
    initBMap(center)
  }, [center])
  // 画出所有门店位置
  useEffect(() => {
    if (stores.length) {
      stores.forEach(({ lbsLng, lbsLat, storeName }) => {
        // 自定义图标
        const myIcon = new BMap.Icon(LBSImg, new BMap.Size(28, 29))
        const pt = new BMap.Point(lbsLng, lbsLat)
        const marker = new BMap.Marker(pt, {
          icon: myIcon
        })
        // 自定义图标的标注
        let opts = {
          position: new BMap.Point(lbsLng, lbsLat), // 指定文本标注所在的地理位置
          offset: new BMap.Size(-20, 10) // 设置文本偏移量
        }
        let label = new BMap.Label(storeName, opts)
        label.setStyle({
          border: 'none',
          background: 'transparent'
        })
        map.addOverlay(marker)
        map.addOverlay(label)
      })
    }
  }, [stores])
  return (
    <div className='location-map-area'>
      <div className='local-search'>
        <div className='search-input'>
          <div className='input-right'>
            <IonInput
              placeholder={i18n.t('location.enterShippingAddressCn')} onFocus={() => setIsSearch(true)} onIonChange={(e: any) => searchLocal(e.detail.value)} onIonBlur={(e: any) => {
                if (!e.detail.value && searchArr.length === 0) {
                  setIsSearch(false)
                }
              }}
              clearInput
            />
          </div>
        </div>
      </div>
      <div className='map-show-area '>
        {
          window.initBaiduMapSDKStatus === 'success' ? (
            <>
              <div className='baidu-map-show' id={id} ref={baiduRef}></div>
              {isDraging &&
                <div className='baidu-map-marker'>
                  <img src={markerImg} alt='' />
                </div>}
            </>
          ) : (
            <div className='map-error'>
              <i className='iconfont icon-togo0'></i>
              <span>{i18n.t('common.page404')}</span>
            </div>
          )
        }
      </div>
      <div className='local-recom'>
        {
          recomArr.map((item: any, index: number) => {
            return (
              <div
                key={index}
                className='search-item'
                data-cypid={`baiduMapLocalSearchItem_${index}`}
                onClick={() => {
                  hanlderSelect(item)
                }}
              >
                <div className='left'>
                  <i className='iconfont icon-togo0' style={{ color: index === 0 ? '#E50E2B' : '#c6c6c6' }}></i>
                </div>
                <div className='right'>
                  <div className='title'>{item.title}</div>
                  <div className='des'>{item.address || ''}</div>
                </div>
              </div>
            )
          })
        }
      </div>
      {
        isSearch && (
          <div
            className='search-area'
          >
            {
              searchArr.map((item: any, index: number) => {
                return (
                  <div
                    key={index}
                    className='search-item'
                    data-cypid={`baiduMapAreaSearchItem_${index}`}
                    onClick={(e: any) => {
                      e.stopPropagation()
                      hanlderSelect(item)
                    }}
                  >
                    <div className='title'>{item.title}</div>
                    <div className='des'>{item.province}{item.city}{item.address || ''}</div>
                  </div>
                )
              })
            }
            {
              searchEmpty && (
                <Empty msg={i18n.t('location.enterShippingAddressCn')} height='55vh' />
              )
            }
          </div>
        )
      }
    </div>
  )
}

export default BaiduMap
